declare const __BUILD_ENVIRONMENT__: string;
declare const __BUILD_COMMIT__: string;
declare const __BUILD_BRANCH__: string;

export default {
    environment: __BUILD_ENVIRONMENT__,
    commit: __BUILD_COMMIT__,
    branch: __BUILD_BRANCH__,
};
